import { staticListProductListLineStyles } from "@insite/content-library/Widgets/StaticList/StaticListProductListLine";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

staticListProductListLineStyles.productPartNumbersStyles = {
    erpNumberGridItem: {
        css: css`
            flex-direction: row;
        `,
    },
};
staticListProductListLineStyles.partNumbersGridItem = {
    width: 12,
    css: css`
        padding-left: 0;
    `,
};
staticListProductListLineStyles.productPriceStyles = {
    priceLabelText: {
        variant: "p",
        weight: 600,
        css: css`
            font-size: 14px;
            font-family: ${getProp("theme.typography.p.fontFamily")};
            @media print {
                font-size: 12px;
            }
            margin-bottom: 0.5rem;
        `,
    },
};
staticListProductListLineStyles.priceGridItem = {
    width: [12, 12, 12, 12, 5],
    printWidth: 5,
    css: css`
        flex-direction: column;
        h4 {
            color: ${getColor("common.backgroundContrast")};
        }
        & > div {
            margin: initial;
        }
    `,
};
